<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="card-gis-filter">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="1">
              <div class="row mt-3">
                <!-- <div class="col-1 text-right">
                  <label for="" style="color:transparent">Todas</label>
                  <el-checkbox
                    label="Todas"
                    v-model="formData.allFarms"
                    @change="allFarmsChange"
                    class="select-primary custom-width-select mt-2"
                  >
                  </el-checkbox>
                </div> -->

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label>{{ $t('common_words.farm') }}: </label>
                  <el-select
                    multiple
                    clearable
                    filterable
                    v-bind:collapse-tags="true"
                    class="select-primary custom-width-select mb-3 shadow-sm required-station"
                    :placeholder="`${$t('common_words.select2')}...`"
                    v-model="farmSel"
                    value-key="id"
                    @change="
                      getSensors();
                      selectAllFromSelect('farmSel', farms);
                    "
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(farm, index) in farms"
                      :key="index"
                      :label="farm.name"
                      :value="farm.id"
                    >
                    </el-option>
                  </el-select>
                  <!-- <label for="">Estación: </label>
                                    <el-select
                                    clearable
                                    filterable
                                    class="select-default custom-width-select mb-3 shadow-sm required-station"
                                    :placeholder="`${$t('common_words.select2')}...`"
                                    v-model="formData.station"
                                    value-key="id"
                                    @change="getSensors()"
                                    >
                                        <el-option
                                            class="select-default"
                                            v-for="(station, index) in stations"
                                            :key="index"
                                            :label="station.name"
                                            :value="station.id">
                                        </el-option>
                                    </el-select> -->
                </div>
                <div
                  :class="`col-12 col-sm-6 col-md-4 col-lg-4 col-xl-${
                    formData.useRange === 'Semanal' ? `3` : `2`
                  }`"
                >
                  <label for="">{{ $t('devices.sensor') }}: </label>
                  <el-select
                    clearable
                    filterable
                    class="select-default custom-width-select mb-3 shadow-sm required-sensor"
                    :placeholder="`${$t('common_words.select2')}...`"
                    v-model="formData.sensor"
                    value-key="name"
                    @change="getYears"
                  >
                    <el-option
                      class="select-default"
                      v-for="(sensor, index) in availableSensors"
                      :key="index"
                      :label="sensor.name"
                      :value="sensor"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                  <label>Tipo de reporte *</label>
                                  <br />
                                  <el-select
                                      clearable
                                      v-bind:collapse-tags="true"
                                      filterable
                                      class="select-primary custom-width-select required-type shadow-sm"
                                      size="large"
                                      v-model="formData.report_type"
                                      :placeholder="`${$t('common_words.select')}...`">
                                      <el-option
                                        v-for="(option,index) in optionsInterval"
                                        class="select-primary"
                                        :value="option.value"
                                        :label="option.label"
                                        :key="index"
                                      ></el-option>
                                  </el-select>
                              </div> -->
                <!-- </div> -->
                <!-- <div class="row mt-3"> -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2">
                  <label>{{ $t('common_words.date_range') }}</label>
                  <br />
                  <el-select
                    clearable
                    v-bind:collapse-tags="true"
                    filterable
                    class="select-primary custom-width-select required-farm shadow-sm"
                    size="large"
                    v-model="formData.useRange"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in [
                        { name: 'Semanal', id: 1 },
                        { name: 'Intervalo', id: 2 },
                      ]"
                      class="select-primary"
                      :value="option.name"
                      :label="option.name"
                      :key="index + option.id"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-12 col-sm-6 col-md-3"
                  v-if="formData.useRange == 'Intervalo'"
                >
                  <label for="">{{ $t('common_words.date') }}: </label>
                  <el-date-picker
                    v-if="renderComponent"
                    class="shadow-sm"
                    :clearable="false"
                    v-model="rangeDate"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="-"
                    :start-placeholder="$t('common_words.starting_date')"
                    :end-placeholder="$t('common_words.final_date')"
                    :align="'right'"
                  >
                  </el-date-picker>
                </div>
                <div
                  class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                  style="padding-right: 0"
                  v-if="formData.useRange == 'Semanal'"
                >
                  <label for="">{{ $t('common_words.date') }}: </label>
                  <el-select
                    :placeholder="`${$t('common_words.select')}...`"
                    clearable
                    @clear="formData.year = null"
                    filterable
                    class="select-primary custom-width-select required-year shadow-sm"
                    size="large"
                    v-model="formData.year_sel_init"
                  >
                    <el-option
                      v-for="(option, index) in years"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                  style="padding-top: 32px"
                  v-if="
                    formData.year_sel_init && formData.useRange == 'Semanal'
                  "
                >
                  <el-select
                    clearable
                    @clear="formData.week_sel_init = null"
                    filterable
                    class="select-primary custom-width-select required-week shadow-sm"
                    size="large"
                    v-model="formData.week_sel_init"
                  >
                    <el-option
                      v-for="(option, index) in 53"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-12 col-md-4 col-xl-2">
                  <label class="label-primary" style="color: transparent">{{
                    $t('common_words.filter')
                  }}</label
                  ><br />
                  <l-button
                    wide
                    type="info"
                    class="btn-filter"
                    @click="validate"
                  >
                    {{ $t('common_words.filter') }}
                  </l-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </card>
        <br />
        <card>
          <div class="row">
            <div class="col-12 map-climate">
              <div
                ref="map"
                class="map"
                v-if="renderComponent"
                style="height: 800px"
              ></div>
              <div
                id="toolbarDiv"
                class="esri-component esri-widget"
                v-if="renderComponent"
              >
                <button
                  id="distance"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.distance_measurement_tool')"
                ></button>
                <button
                  id="area"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.area_measurement_tool')"
                ></button>
                <button
                  id="clear"
                  class="action-button esri-widget--button esri-interactive esri-icon-trash"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.clear_measurement')"
                ></button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Checkbox } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      center: {
        lat: 10.947212,
        lng: -74.203901717,
      },
      activeName: '1',
      formData: {
        // report_type:null,
        year_sel_init: null,
        week_sel_init: null,
        useRange: 'Semanal',
        init: null,
        end: null,
        station: null,
        farm_id: null,
        business_id: [],
        sensor: null,
        sensor_name: null,
        allFarms: false,
      },
      reports: [],
      sensors: [],
      stations: [],
      renderComponent: true,
      rangedate: null,
      isShowCalendar: false,
      farms: [],
      farmSel: [],
      // optionsInterval: {
      //   0: {"label" : "Consolidado", "value" : "consolidado"},
      //   1: {"label" : "Detallado", "value" : "detallado"}
      // },
      mapData: {},
      kmlLayer: null,
      map: null,
      years: [],
      valueCollapse: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinArcgisMap,
    mixinMasters,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  computed: {
    availableSensors() {
      let allowedSensors = ['6', '600', '506'];
      return this.sensors.filter((sensor) =>
        allowedSensors.includes(sensor.code)
      );
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    allFarmsChange() {
      if (this.formData.allFarms) {
        this.farmSel = this.farms.map((farm) => farm.id);
      } else {
        this.farmSel = [];
      }
      this.getSensors();
    },

    validate() {
      if (this.formData.station == null) {
        return this.validationInputsRequired('station');
      } else if (this.formData.sensor == null) {
        return this.validationInputsRequired('sensor');
      } else if (
        this.formData.year_sel_init == null &&
        this.formData.useRange == 'Semanal'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.formData.week_sel_init == null &&
        this.formData.useRange == 'Semanal'
      ) {
        return this.validationInputsRequired('week');
      } else {
        this.loadReport();
      }
    },

    getYears($sensor) {
      Axios.getMasters(
        `gis/climates/minyear/${$sensor.id}/${this.formData.station}`
      )
        .then((response) => {
          this.years = response.data;
        })
        .catch((error) => {
          SweetAlert.warning(i18n.t('sweet_alert.gis.loading_error'));
        });
    },

    loadReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'gis/climates/climatemapuniban';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.reports = response.data.data;
            this.center.lat = response.data.center.lat;
            this.center.lng = response.data.center.lng;
            this.loadMap('filtrar');
          }
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    loadData() {
      let data = {
        station: this.formData.station,
        sensor: this.formData.sensor.id,
        useRange: this.formData.useRange,
        business: this.formData.business_id,
        // report_type: this.formData.report_type,
        sensor_code: this.formData.sensor.code,
        sensor_name: this.formData.sensor.name,
        farms: this.farmSel,
        init: null,
        end: null,
      };

      switch (this.formData.useRange) {
        case 'Semanal':
          data.init =
            parseInt(this.formData.year_sel_init) * 100 +
            parseInt(this.formData.week_sel_init);
          // data.end = parseInt(this.formData.year_sel_end) * 100 + parseInt(this.formData.week_sel_end);
          break;
        case 'Intervalo':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');

          break;
      }

      return data;
    },

    getSensors() {
      this.sensors = [];
      let data = {
        route: 'gis/climates/getSensorsCustom',
        farms: this.farmSel,
      };
      if (data.farms.length > 0) {
        Axios.postMasters(data)
          .then((response) => {
            this.sensors = response.data;
            if (response.data.length > 0) {
              this.formData.station = response.data[0].climate_station_id;
            }
          })
          .catch((error) => {
            SweetAlert.warning(i18n.t('sweet_alert.gis.loading_sensors_error'));
            console.log(error);
          });
      }

      // this.farms= [];
      // Axios.getMasters(`gis/climates/getFarmsClima/${this.formData.station}`)
      // .then((response) => {
      //   this.farms = response.data;
      // })
      // .catch((error) => {
      //   SweetAlert.warning('Error al cargar fincas');
      // });
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    loadMap(where) {
      this.renderComponent = false;
      this.showHideLoading(true);
      let namesFiles = [];
      let centers = [];

      for (let index = 0; index < this.farms.length; index++) {
        if (
          this.reports
            .map((x) => x['title'])
            .includes(this.farms[index]['name'])
        ) {
          this.center = {
            lat: this.farms[index].latitude,
            lng: this.farms[index].longitude,
          };

          centers.push(this.center);
          if (
            this.farms[index].other_values &&
            JSON.parse(this.farms[index].other_values).files
          ) {
            JSON.parse(this.farms[index].other_values)
              .files.reverse()
              .forEach((element) => {
                namesFiles.push(
                  this.farms[index].id +
                    '/' +
                    element +
                    '|' +
                    this.farms[index].name
                );
              });
          }
        }
      }

      this.$nextTick(() => {
        this.renderComponent = true;
        if (where == 'created') {
          this.loadMapClima(
            true,
            centers,
            ['Perimetro'],
            namesFiles,
            this.reports,
            ''
          );
        } else if (where == 'filtrar') {
          this.loadMapClima(
            false,
            centers,
            ['Perimetro'],
            namesFiles,
            this.reports,
            ''
          );
        }

        this.showHideLoading();
        setTimeout(() => {
          document.getElementById('toolbarDiv').style =
            'top: 19% !important;right: 30px;';
        }, 10);
      });
    },
  },

  created() {
    this.showHideLoading(true);
    let business_ids = [];
    this.$store.state.auth.user.business.forEach((business) => {
      business_ids.push(business.id);
    });

    this.formData.business_id = business_ids;

    // let data = {
    //   business:this.formData.business_id,
    //   route: 'gis/climates/getAllBusinessStations'
    // };

    Axios.getMasters('farms/farms/only')
      .then((response) => {
        if (response.data) {
          // this.stations = response.data;
          this.farms = this.concatAll(response.data.data);
          this.loadMap('created');
        }
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        console.log(error);
      });

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = Object.keys(response.data).reverse();
      this.showHideLoading();
    });
  },

  mounted() {
    this.selectedItemOnMenu('gis');
  },

  destroyed() {
    this.deselectedItemOnMenu('gis');
  },
};
</script>

<style scoped>
#toolbarDiv {
  top: 12% !important;
  margin-top: 0px;
  padding-top: 0px;
}
</style>
